import React, { useEffect, useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchCoachesRequest } from '../../../redux/coach/coachSlice';
import CoachesTable from '../CoachesTable';
import CoachesEmpty from './CoachesEmpty';
import { activeCoachesColumns } from '../Columns';
import { CoachesProps } from '../../../pages/Coaches/Coaches';
import { CoachBrandTagsTypes } from '../../../types/coach';

const ActiveCoaches = ({
  pageSize,
  currentPage,
  skip,
  handleOnPaginationModelChange,
}: CoachesProps) => {
  const dispatch = useAppDispatch();
  const [initialRender, setInitialRender] = useState(true);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [exisitingCoach, setExistingCoach] = useState<boolean>(false);
  const [brandTag, setBrandTag] = useState<string>();

  const coach = useAppSelector((state) => state.coach.coaches);
  const { coaches, totalCoachesCount, coachesLoading } = useAppSelector((state) => state.coach);

  useEffect(() => {
    if (totalCoachesCount > 0 && !exisitingCoach) {
      setExistingCoach(true);
    }
  }, [totalCoachesCount, exisitingCoach]);

  const fetchCoaches = () => {
    if (coach) {
      const payload = {
        organizationId: 'decb4748-9dba-4672-b0c2-88aad43fc307',
        nameText: searchTerm,
        skip,
        take: pageSize,
        archived: false,
      };
      if (brandTag === CoachBrandTagsTypes.ALL || !brandTag) {
        dispatch(fetchCoachesRequest(payload));
      } else {
        dispatch(fetchCoachesRequest({ ...payload, brandTag }));
      }
    }
  };
  const coachesFilterhandler = (event) => {
    const { value } = event.target;
    setBrandTag(value);
  };

  useEffect(() => {
    if (!initialRender) {
      fetchCoaches();
    } else {
      setInitialRender(false);
    }
  }, [pageSize, currentPage, brandTag]);

  useEffect(() => {
    if (!initialRender) {
      const debounceSearch = setTimeout(() => {
        fetchCoaches();
      }, 1000);
      return () => clearTimeout(debounceSearch);
    }
  }, [searchTerm, dispatch]);

  const handleChangeSearchTerm = (newValue: string) => {
    setSearchTerm(newValue);
  };

  return !coachesLoading && totalCoachesCount === 0 && !exisitingCoach ? (
    <CoachesEmpty />
  ) : (
    <CoachesTable
      rows={!coachesLoading ? coaches : []}
      rowCount={totalCoachesCount}
      loading={coachesLoading}
      columns={activeCoachesColumns}
      handleOnPaginationModelChange={handleOnPaginationModelChange}
      handleOnChangeSearchTerm={handleChangeSearchTerm}
      searchTerm={searchTerm}
      pageSize={pageSize}
      page={currentPage}
      coachesFilterhandler={coachesFilterhandler}
      selectedbrandTag={brandTag}
    />
  );
};

export default ActiveCoaches;
